import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Badge, Button, Table, Pagination } from "react-bootstrap";

const CPAPServiceItem = ({
  items,
  onEdit,
  onDelete,
  onCopy,
  totalItems,
  totalPages,
  currentPage,
  itemsPerPage,
  goToPage,
  isStart,
  isEnd,
  getNext,
  getPrev,
}) => {
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table mb-0 table-striped">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Brand</th>
                      <th>Model</th>
                      <th>With Humidifier</th>
                      <th>Price</th>
                      <th>Humidifier Price</th>
                      <th>Tube Price</th>
                      <th>Rental Price</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody id="cpap-service-table">
                    {items.map((item, index) => {
                      return (
                        <tr className="btn-reveal-trigger" key={item.id}>
                          <td className="py-1">
                            {index + 1 + (currentPage - 1) * itemsPerPage}
                          </td>
                          <td className="py-2">{item.brand}</td>
                          <td className="py-2">{item.model}</td>
                          <td className="py-2">{item.withHumidifier}</td>
                          <td className="py-2">{item.price}</td>
                          <td className="py-2">{item.humidifierPrice}</td>
                          <td className="py-2">{item.tubePrice}</td>
                          <td className="py-2">{item.rentalPrice}</td>
                          <td className="py-1">{item.IsActive}</td>
                          <td className="py-2 text-right">
                            <div className="d-flex">
                              <Link
                                className="btn btn-primary shadow btn-xs sharp mr-1"
                                to="#"
                                onClick={() => onEdit(item.id)}
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Edit CPAP service details"
                              >
                                <i className="fa fa-pencil"></i>
                              </Link>
                              <Link
                                to="#"
                                className="btn btn-info shadow btn-xs sharp mr-1"
                                onClick={() => onCopy(item.id)}
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Copy CPAP service"
                              >
                                <i className="fa fa-copy"></i>
                              </Link>
                              <Link
                                to="#"
                                className="btn btn-danger shadow btn-xs sharp mr-1"
                                onClick={() => onDelete(item.id)}
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Delete CPAP service"
                              >
                                <i className="fa fa-close"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="dataTables_info">
                  Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                  {totalItems < (currentPage + 1) * itemsPerPage
                    ? totalItems
                    : currentPage * itemsPerPage}{" "}
                  of {totalItems} entries
                </div>
                <div className="dataTables_paginate paging_simple_numbers">
                  <Pagination
                    className="pagination-primary pagination-circle"
                    size="lg"
                  >
                    <Pagination.Prev onClick={getPrev} disabled={isStart} />
                    {pageNumbers.map((number) => (
                      <Pagination.Item
                        key={number}
                        active={number === currentPage}
                        onClick={() => goToPage(number)}
                      >
                        {number}
                      </Pagination.Item>
                    ))}
                    <Pagination.Next onClick={getNext} disabled={isEnd} />
                  </Pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CPAPServiceItem;
